import { RootState } from '@react-three/fiber'
import _ from 'lodash'

export const screenshot = (threeState: RootState) => () => {
  const scene = threeState.scene
  const gl = threeState.gl
  const k3d = scene.getObjectByName('k3d')
  const staticScene = scene.getObjectByName('staticScene')
  const cloneEnv = _.cloneDeep(scene.background)
  scene.background = null
  gl.setClearColor(0x000000, 0)

  if (staticScene) {
    staticScene.visible = false
  }

  gl.render(threeState.scene, threeState.camera)

  const link = document.createElement('a')
  link.setAttribute('download', 'canvas.png')
  link.setAttribute(
    'href',
    gl.domElement
      .toDataURL('image/png')
      .replace('image/png', 'image/octet-stream')
  )
  link.click()

  scene.background = cloneEnv
  if (staticScene) {
    staticScene.visible = true
  }

  gl.render(threeState.scene, threeState.camera)
}
